(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.state = Game.copyState(initialState);
        this.initialState = Game.copyState(initialState);
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "move",
            value: function move(direction) {
                if (this.status === "playing") {
                    var changed = false;
                    for(var i = 0; i < 4; i++){
                        var original = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.state[i]);
                        var newRow = direction === "left" ? Game.moveRowLeft(original, this) : Game.moveRowRight(original, this);
                        if (!changed && newRow.toString() !== original.toString()) changed = true;
                        this.state[i] = newRow;
                    }
                    if (changed) {
                        this.addRandomTile();
                        if (!this.canMove()) this.status = "lose";
                    }
                }
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                this.move("left");
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.move("right");
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    var value = this.state[r][c];
                    if (value === 0) return true;
                    if (c < 3 && value === this.state[r][c + 1]) return true;
                    if (r < 3 && value === this.state[r + 1][c]) return true;
                }
                return false;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.status === "playing") {
                    var changed = false;
                    for(var c = 0; c < 4; c++){
                        var originalColumn = [
                            this.state[0][c],
                            this.state[1][c],
                            this.state[2][c],
                            this.state[3][c]
                        ];
                        var newColumn = Game.moveColumnUp(originalColumn, this);
                        if (!changed && newColumn.toString() !== originalColumn.toString()) changed = true;
                        for(var r = 0; r < 4; r++)this.state[r][c] = newColumn[r];
                    }
                    if (changed) {
                        this.addRandomTile();
                        if (!this.canMove()) this.status = "lose";
                    }
                }
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status === "playing") {
                    var changed = false;
                    for(var c = 0; c < 4; c++){
                        var originalColumn = [
                            this.state[0][c],
                            this.state[1][c],
                            this.state[2][c],
                            this.state[3][c]
                        ];
                        var newColumn = Game.moveColumnDown(originalColumn, this);
                        if (!changed && newColumn.toString() !== originalColumn.toString()) changed = true;
                        for(var r = 0; r < 4; r++)this.state[r][c] = newColumn[r];
                    }
                    if (changed) {
                        this.addRandomTile();
                        if (!this.canMove()) this.status = "lose";
                    }
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return Game.copyState(this.state);
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.state[r][c] === 0) emptyCells.push([
                        r,
                        c
                    ]);
                }
                if (emptyCells.length > 0) {
                    var randomIndex = Math.floor(Math.random() * emptyCells.length);
                    var _emptyCells_randomIndex = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[randomIndex], 2), row = _emptyCells_randomIndex[0], col = _emptyCells_randomIndex[1];
                    var newValue = Math.random() < 0.9 ? 2 : 4;
                    this.state[row][col] = newValue;
                }
            }
        },
        {
            key: "start",
            value: function start() {
                this.score = 0;
                this.status = "playing";
                this.addRandomTile(2);
                this.addRandomTile(2);
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = Game.copyState(this.initialState);
                this.score = 0;
                this.status = "idle";
            }
        }
    ], [
        {
            key: "copyState",
            value: function copyState(state) {
                return state.map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            key: "moveRowLeft",
            value: function moveRowLeft(row, game) {
                var filteredRow = row.filter(function(value) {
                    return value !== 0;
                });
                for(var i = 0; i < filteredRow.length - 1; i++)if (filteredRow[i] === filteredRow[i + 1]) {
                    filteredRow[i] *= 2;
                    filteredRow[i + 1] = 0;
                    game.score += filteredRow[i];
                    if (filteredRow[i] === 2048) game.status = "win";
                }
                filteredRow = filteredRow.filter(function(value) {
                    return value !== 0;
                });
                while(filteredRow.length < 4)filteredRow.push(0);
                return filteredRow;
            }
        },
        {
            key: "moveRowRight",
            value: function moveRowRight(row, game) {
                var filteredRow = row.filter(function(value) {
                    return value !== 0;
                });
                for(var i = filteredRow.length - 1; i > 0; i--)if (filteredRow[i] === filteredRow[i - 1]) {
                    filteredRow[i] *= 2;
                    filteredRow[i - 1] = 0;
                    game.score += filteredRow[i];
                    if (filteredRow[i] === 2048) game.status = "win";
                }
                filteredRow = filteredRow.filter(function(value) {
                    return value !== 0;
                });
                while(filteredRow.length < 4)filteredRow.unshift(0);
                return filteredRow;
            }
        },
        {
            key: "moveColumnUp",
            value: function moveColumnUp(col, game) {
                var filteredColumn = col.filter(function(value) {
                    return value !== 0;
                });
                for(var i = 0; i < filteredColumn.length - 1; i++)if (filteredColumn[i] === filteredColumn[i + 1]) {
                    filteredColumn[i] *= 2;
                    filteredColumn[i + 1] = 0;
                    game.score += filteredColumn[i];
                    if (filteredColumn[i] === 2048) game.status = "win";
                }
                filteredColumn = filteredColumn.filter(function(value) {
                    return value !== 0;
                });
                while(filteredColumn.length < 4)filteredColumn.push(0);
                return filteredColumn;
            }
        },
        {
            key: "moveColumnDown",
            value: function moveColumnDown(col, game) {
                var filteredColumn = col.filter(function(value) {
                    return value !== 0;
                });
                for(var i = filteredColumn.length - 1; i > 0; i--)if (filteredColumn[i] === filteredColumn[i - 1]) {
                    filteredColumn[i] *= 2;
                    filteredColumn[i - 1] = 0;
                    game.score += filteredColumn[i];
                    if (filteredColumn[i] === 2048) game.status = "win";
                }
                filteredColumn = filteredColumn.filter(function(value) {
                    return value !== 0;
                });
                while(filteredColumn.length < 4)filteredColumn.unshift(0);
                return filteredColumn;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$game = new (0, (/*@__PURE__*/$parcel$interopDefault($3d28d7f1aac198f5$exports)))();
var $197cd56b15c33885$var$startButton = document.querySelector(".button.start");
var $197cd56b15c33885$var$cells = Array.from(document.querySelectorAll(".field-cell"));
function $197cd56b15c33885$var$renderGameBoard(state) {
    $197cd56b15c33885$var$cells.forEach(function(cell, index) {
        var row = Math.floor(index / 4);
        var col = index % 4;
        var value = state[row][col];
        cell.textContent = value !== 0 ? value : "";
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add("field-cell--".concat(value));
    });
}
var $197cd56b15c33885$var$restartButton = document.createElement("button");
var $197cd56b15c33885$var$controlPanel = document.querySelector(".controls");
$197cd56b15c33885$var$restartButton.classList.add("button");
$197cd56b15c33885$var$restartButton.classList.add("restart");
$197cd56b15c33885$var$restartButton.textContent = "Restart";
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$renderGameBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$startButton.remove();
    $197cd56b15c33885$var$controlPanel.append($197cd56b15c33885$var$restartButton);
    document.querySelector(".message-start").classList.add("hidden");
});
$197cd56b15c33885$var$restartButton.addEventListener("click", function() {
    $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$renderGameBoard($197cd56b15c33885$var$game.getState());
    $197cd56b15c33885$var$restartButton.remove();
    $197cd56b15c33885$var$controlPanel.append($197cd56b15c33885$var$startButton);
    document.querySelector(".message-start").classList.remove("hidden");
    if (document.querySelector(".message-lose")) document.querySelector(".message-lose").classList.add("hidden");
});
document.addEventListener("keydown", function(e) {
    if (e.key === "ArrowRight") {
        $197cd56b15c33885$var$game.moveRight();
        $197cd56b15c33885$var$renderGameBoard($197cd56b15c33885$var$game.getState());
    }
    if (e.key === "ArrowLeft") {
        $197cd56b15c33885$var$game.moveLeft();
        $197cd56b15c33885$var$renderGameBoard($197cd56b15c33885$var$game.getState());
    }
    if (e.key === "ArrowUp") {
        $197cd56b15c33885$var$game.moveUp();
        $197cd56b15c33885$var$renderGameBoard($197cd56b15c33885$var$game.getState());
    }
    if (e.key === "ArrowDown") {
        $197cd56b15c33885$var$game.moveDown();
        $197cd56b15c33885$var$renderGameBoard($197cd56b15c33885$var$game.getState());
    }
    var scorePoints = document.querySelector(".game-score");
    scorePoints.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getStatus() === "lose") document.querySelector(".message-lose").classList.remove("hidden");
    if ($197cd56b15c33885$var$game.getStatus() === "win") document.querySelector(".message-win").classList.remove("hidden");
});

})();
//# sourceMappingURL=2048game.b0f57b31.js.map
